import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ValidationErrorData } from '../../typings/common';

import './ErrorText.css';

export enum ErrorTextTheme {
    clear = 'clear',
    tooltip = 'tooltip'
}

export interface ErrorTextProps {
    errors?: ValidationErrorData[];
    theme?: ErrorTextTheme;
}

const blockClass = 'error-text';

export const ErrorText = React.memo((props: ErrorTextProps) => {
    const { errors, theme = ErrorTextTheme.clear } = props;

    if (!errors || errors.length === 0) {
        return null;
    }

    return (
        <div className={Bem.cls({ block: blockClass, mods: { theme: theme } })}>
            {errors.map((error: ValidationErrorData, index) => (
                <div
                    className={Bem.cls(blockClass, 'error-item')}
                    key={
                        error.path !== undefined && error.code !== undefined ? error.path + error.code : 'error' + index
                    }
                >
                    {error.text}
                </div>
            ))}
        </div>
    );
});
